export enum OrganizationType {
  HealthcareProvider = 'HEALTHCARE_PROVIDER',
  InsuranceProvider = 'INSURANCE_PROVIDER',
}
